import React from "react";
import { Download, X } from "lucide-react";
import { useInstall } from "../lib/install.jsx";

export default function PWAInstall() {
  const { canInstall, installed, triggerInstall } = useInstall();
  const [hidden, setHidden] = React.useState(false);

  if (installed || !canInstall || hidden || (typeof window !== "undefined" && localStorage.getItem("pwa_dismissed") === "1")) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-40">
      <div className="brimi-card flex items-center gap-3 p-4 max-w-sm ml-auto" data-testid="pwa-prompt">
        <div className="p-2 rounded-xl bg-brimi-navy/10 text-brimi-navy">
          <Download size={18} />
        </div>
        <div className="flex-1">
          <p className="font-semibold text-sm text-brimi-navyText">Install BrimiH&G</p>
          <p className="text-xs text-brimi-navyText/70">Faster access, works full-screen.</p>
        </div>
        <button
          className="brimi-btn-primary !py-2 !px-3 text-xs"
          onClick={triggerInstall}
          data-testid="pwa-install-btn"
        >
          Install
        </button>
        <button
          onClick={() => {
            localStorage.setItem("pwa_dismissed", "1");
            setHidden(true);
          }}
          className="text-brimi-navyText/50 hover:text-brimi-navyText"
          data-testid="pwa-dismiss-btn"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
